"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = function _default(obj, prop) {
  var defaultValue = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  if (obj && prop in obj) return obj[prop];
  return defaultValue;
};
exports["default"] = _default;